export default __webpack_public_path__ + "static/media/ED489A9D-2813-4B36-AA36-3257A0258BEE_1_105_c.1a5a0458.jpeg";